import React from "react";
import { Grid } from "semantic-ui-react";
import SportList from "../athletes/SportList";

const SportDropDown = ({ getValue, getError }) => {
  const handleChange = (data) => {
    if (data) {
      getValue(data);
      getError(null);
    } else getError(`Choose sport`);
  };
  return (
    <Grid.Column mobile={16} tablet={8} computer={8}>
      <div className="form-group">
        <label htmlFor="position">
          Enter Sport <span className="required">*</span>
        </label>
        <SportList
          className="cu-form-groups-dropdown"
          name="sport"
          placeholder="Enter Sport"
          onChange={(e, { value }) => handleChange(value)}
        />
      </div>
    </Grid.Column>
  );
};

export default SportDropDown;
